/* 🤖 this file was generated by svg-to-ts*/
export const icoHeartFilled: {
  name: 'heart-filled';
  data: string;
} = {
  name: 'heart-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.75 3.006c-1.584.076-3.114.872-4.592 2.339l-.158.16-.158-.16C10.286 3.8 8.673 3 7 3 3.576 3 2 5.206 2 9c0 4.098 3.212 8.024 9.479 11.853a1 1 0 001.043 0C18.788 17.023 22 13.098 22 9c0-4.104-1.459-6-5-6l-.25.006z" fill="#909090"/></svg>`
};
